import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { fetchCart } from "../../Utils/Redux/CartSlice";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import TopTitleBar from "../DashBoard/ExternalDash/TopTitleBar";
import { ADD_MONEY, BASE_URL, EXPORT_TRANSACTION_HISTORY, VERIFY_WALLET } from "../../Utils/constant";
import cogoToast from "cogo-toast-react-17-fix";
import { MESSAGE } from "../../Utils/Strings";
import API from '../../ApiConfig'
import Pagination from "../DashBoard/ExternalDash/Pagination";
import AnimatedLoader from "../../components/AnimationLoader";
import { convertDateFormat } from "../../Utils/helper";
import Loader from "../../components/Loader";
import { AuthConsole } from "../../Utils/helper"
import Records from './records';
const CreditDetails = () => {
   const dispatch = useDispatch();
      const [loading, setLoading] = useState(false)
      const credit = useSelector((state) => state.credit.data);
      const User = useSelector(state => state.User)
      const [data, setData] = useState({})
      const [sortBy, setSortBy] = useState(4)
      const [orderBy, setOrderby] = useState(true)
      let lables = ['amount', 'description', 'source', 'payment_method', 'created_at', 'credit','debit']
      const UserDetails=useSelector(state=>state.cart.user)
      // pagination
      const [currentPage, setCurrentPage] = useState(1)
      const [totalPages, setTotalPages] = useState(0)
      const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
      const [pdfLoading, setPDFLoading]=useState(false)
      const handlePageChange = (nextPage) => {
        setCurrentPage(nextPage);
    }


     useEffect(() => {
            fetchCreditHistory()
        }, [currentPage, orderBy])

        const setOrder = (sort) => {
          if (sort == sortBy) {
              setOrderby(!orderBy)
          }
          else {
              setSortBy(sort)
              setOrderby('desc')
          }
      }
      
    const fetchCreditHistory = () => {
            const GET_Credit_HISTORY = '/api/v1/credit/history'
            const filters = `?sort_by=${lables[sortBy]}&sort_order=${orderBy ? 'desc' : 'asc'}&page=${currentPage}`
            API.get(GET_Credit_HISTORY + filters)
                .then(res => {
                    if (res.data.status === 200) {
                        setData(res.data.data)
                        setCurrentPage(res.data.data.current_page)
                        setTotalPages(res.data.data.total_pages)
                    }
                })
                .catch(err => {
                    cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
                })
        }
        const handleDateChange = (field, e) => {
          setDateRange((prev) => ({ ...prev, [field]: e }));
        }
  return (
    <SlideUpWrapper>
            <AnimatedLoader isOpen={loading} loadingText={"Processing your payment"}/>
                <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'>Your Credit</span></h2></TopTitleBar>
                <section className="table-header6 " style={{ justifyContent: "center", alignItems: 'center' }}>
                    <div>
                        <h1 className="heading">
                            Balance: {credit.total_credits} Credits
                        </h1>
                    {/* {User.user_type=="Issuer"?null:    <div className="table-header6 ">
                            <div className="issuer-input-wrapper">
                                <input type="number" className="issuer-input" value={amount} min={0} max={25000} onChange={e => setAmount(e.target.value)}></input>
                            </div>
                            <button onClick={AddMoneyToWallet} className="btn btn-primary">Add Money</button>
                        </div>} */}
    
    
                    </div>
                </section>
            <div className="mb-10 flex justify-between">
            <div>
            <label className="font-bold">Start Date:</label>
                <input
                              type="date"
                              className="datePicker"
                              value={dateRange.startDate}
                              style={{ margin: "10px 25px 0px 25px" }}
                              onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
                            />
            <label className="font-bold">End Date:</label>
                            <input
                              type="date"
                              className="datePicker"
                              value={dateRange.endDate}
                              style={{margin:"10px 25px 0px 25px"}}
                              onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
                            />
            </div>
            {/* <div>
                <button className="btn btn-primary" onClick={(e)=>handleDownload(e)}>Export transactions</button>
            </div> */}
            </div>
                {(data && data.items) && <Records lable={lables} data={data.items} orderBy={orderBy} sortBy={sortBy} setOrder={setOrder} />}
                <div style={{ margin: "10px" }}>
                    <Pagination
                        nPages={totalPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onPageChange={handlePageChange}
                        loading={loading}
                    />
                </div>
            </SlideUpWrapper>
  )
}

export default CreditDetails